import { FC } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Input } from "boomform";

import UserActions from "./UserActions";
import AuthButtons from "./AuthButtons";
import LogoSrc from "./../../assets/images/header/AppLogo.svg";
import { useUser } from "./../../hooks/useUser";
import { IUserTypes } from "./../../store/auth/types";
import { IForm } from "./../../store/forms/types";
import { updateFormNameRequest } from "./../../store/forms/actionCreators";
import { getActiveRoute } from "./../../helpers/getActiveRoute";
import { debounce } from "./../../helpers/debounce";
import { RouteType } from "./../routes/types";

import styles from "./styles.module.scss";

interface IProps {
    name: IForm["name"];
}

const Header: FC<IProps> = ({ name }) => {
    const { userType } = useUser();
    const dispatch = useDispatch();
    const placeholder: string = "Form Name";
    const location = useLocation();
    const activeRoute = getActiveRoute(location.pathname);
    const isEditMode = activeRoute === RouteType.Edit;

    //@ts-ignore
    const handleFormNameChange = e => {
        const name = e.value;
        debounce("changeFormName", () => dispatch(updateFormNameRequest({ name })), 1000);
    };

    return (
        <header className={styles.wrapper}>
            <img src={LogoSrc} alt="boomform-logo" className={styles.logo} />
            <Input
                id="form.name"
                type="text"
                readOnly={!isEditMode}
                placeholder={placeholder}
                initial={name}
                className={styles.formName}
                onChange={handleFormNameChange}
            />
            {userType === IUserTypes.USER ? <UserActions /> : <AuthButtons />}
        </header>
    );
};

export default Header;
